import { render, staticRenderFns } from "./SettingsDialog.vue?vue&type=template&id=2569e2b9&"
import script from "./SettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./SettingsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports